import { MenuTreeType } from "../../types/menu-tree.type";
import { Role } from "./role.model";

export const MenuTree: MenuTreeType[] = [
  {
    menu: "dashboard",
    path: "/analytics-chat",
    label: "MENU.DASHBOARD",
    icon: "fa-solid fa-chart-simple",
    groups: ["/MESSAGING"],
    authorities: [Role.ANALYTICS_CHAT],
  },
  // ------------------ SUPPORT ------------------
  {
    menu: "manage-ticket",
    path: "/manage-ticket",
    label: "MENU.SOLUTION.MANAGE_TICKET",
    icon: "fa-solid fa-ticket",
    groups: ["/SUPPORT"],
    authorities: [Role.MANAGE_TICKET],
  },
  // ------------------ COMMERCE ------------------
  {
    menu: "voucher",
    path: "/voucher",
    label: "MENU.VOUCHER.TITLE",
    icon: "fa-solid fa-receipt",
    groups: ["/VOUCHER"],
    authorities: [Role.MANAGE_VOUCHER],
    items: [
      {
        path: "/voucher/list",
        label: "MENU.VOUCHER.LIST",
        icon: "fa-solid fa-list-ul",
        authorities: [Role.MANAGE_VOUCHER],
      },
      {
        path: "/voucher/import",
        label: "MENU.VOUCHER.IMPORT",
        icon: "fa-solid fa-upload",
        authorities: [Role.MANAGE_VOUCHER],
      },
      {
        path: "/voucher/barre-code",
        label: "MENU.VOUCHER.BARRE_CODE",
        icon: "fa-solid fa-barcode",
        authorities: [Role.MANAGE_VOUCHER],
      },
      {
        path: "/voucher/brodcast",
        label: "MENU.BROADCAST.TITLE",
        icon: "fa-solid fa-bullhorn",
        authorities: [Role.MANAGE_VOUCHER],
      },
    ],
  },
  {
    menu: "order",
    path: "/order",
    label: "MENU.ORDER",
    icon: "fa-solid fa-cart-shopping",
    groups: ["/ORDER"],
    authorities: [Role.ORDERS],
    hideForActivity: "RESERVATION_HOSTELS",
  },
  {
    menu: "product",
    path: "/product",
    label: "MENU.PRODUCT",
    icon: "fa-solid fa-box",
    groups: ["/ORDER"],
    authorities: [Role.PRODUCT],
    hideForActivity: "RESERVATION_HOSTELS",
    items: [
      {
        path: "/product/list",
        label: "MENU.PRODUCT_LIST",
        icon: "fa-solid fa-list-ul",
        authorities: [Role.PRODUCT],
      },
      {
        path: "/product/categories",
        label: "CATEGORY.TITLE",
        icon: "fa-solid fa-layer-group",
        authorities: [Role.PRODUCT],
      },
      {
        path: "/product/manage-crm",
        label: "MENU.CRM.CONNEXION",
        icon: "fa-solid fa-bag-shopping",
        authorities: [Role.PRODUCT],
      },
      {
        path: "/product/crm-products",
        label: "MENU.CRM.LIST",
        icon: "fa-solid fa-store",
        authorities: [Role.PRODUCT],
      },
    ],
  },
  // --- RESERVATION-SPECIFIC COMMERCE MENUS (hidden for ecom) ---
  {
    menu: "delivery",
    path: "/delivery",
    label: "MENU.DELIVERY.TITLE",
    icon: "fa-solid fa-dolly",
    groups: ["/DELIVERY"],
    authorities: [Role.MERCHANT, Role.MANAGE_DELIVERYMAN, Role.PARCELS],
    hideForActivity: "RESERVATION_HOSTELS",
    items: [
      {
        path: "/delivery/merchant",
        label: "MENU.DELIVERY.MERCHANT",
        icon: "fas fa-store",
        authorities: [Role.MERCHANT],
      },
      {
        path: "/delivery/delivery-man",
        label: "MENU.DELIVERY.DELIVERY_MAN",
        icon: "fas fa-shipping-fast",
        authorities: [Role.MANAGE_DELIVERYMAN],
      },
      {
        path: "/delivery/parcel",
        label: "MENU.DELIVERY.PARCEL",
        icon: "fas fa-box",
        authorities: [Role.PARCELS],
      },
    ],
  },
  // ------------------ RESERVATION (one consolidated menu) ------------------
  {
    menu: "reservation",
    path: "/reservation",
    label: "MENU.RESERVATION.TITLE",
    icon: "fa-solid fa-calendar-check",
    groups: ["/ORDER"],
    activityCondition: "RESERVATION_HOSTELS",
    items: [
      {
        path: "/reservation",
        label: "MENU.RESERVATION.CALENDAR",
        icon: "fa-solid fa-calendar-days",
      },
      {
        path: "/product/categories",
        label: "MENU.RESERVATION.CATEGORIES",
        icon: "fa-solid fa-layer-group",
      },
      {
        path: "/product/list",
        label: "MENU.RESERVATION.ROOMS",
        icon: "fa-solid fa-bed",
        queryParams: { itemType: "ROOM" },
      },
      {
        path: "/product/list",
        label: "MENU.RESERVATION.ACTIVITIES",
        icon: "fa-solid fa-concierge-bell",
        queryParams: { itemType: "EXTRA" },
      },
    ],
  },
  // ------------------ MESSAGING ------------------
  {
    menu: "contact",
    path: "/contact",
    label: "MENU.CONTACT.TITLE",
    icon: "fa-solid fa-address-book",
    groups: ["/MESSAGING"],
    authorities: [Role.MANAGE_CONTACT],
    items: [
      {
        path: "/contact/list",
        label: "MENU.CONTACT.LIST",
        icon: "fa-solid fa-list-ul",
        authorities: [Role.MANAGE_CONTACT],
      },
      {
        path: "/contact/upload",
        label: "MENU.CONTACT.UPLOAD",
        icon: "fa-solid fa-upload",
        authorities: [Role.MANAGE_CONTACT],
      },
    ],
  },
  {
    menu: "team-inbox",
    path: "/team-inbox",
    label: "MENU.TEAM_INBOX",
    icon: "fas fa-inbox",
    groups: ["/MESSAGING"],
    authorities: [Role.TEAM_INBOX],
  },
  {
    menu: "template",
    path: "/template",
    label: "MENU.TEMPLATE.TITLE",
    icon: "fa-solid fa-clipboard",
    groups: ["/MESSAGING"],
    authorities: [Role.MANAGE_TEMPLATE, Role.MANAGE_BOTS, Role.MANAGE_FLOW],
    items: [
      /*{
        path: "/template/tracking/list",
        label: "MENU.TEMPLATE.TRACKING",
        icon: "fa-solid fa-chart-line",
        authorities: [Role.MANAGE_TEMPLATE],
      },
      {
        path: "/template/request",
        label: "MENU.TEMPLATE.REQUEST",
        icon: "fa-solid fa-file-export",
        authorities: [Role.MANAGE_TEMPLATE],
      },*/
      {
        path: "/template/list",
        label: "MENU.TEMPLATE.LIST",
        icon: "fa-solid fa-list-ul",
        authorities: [Role.MANAGE_TEMPLATE],
      },
      {
        path: "/template/flow",
        label: "MENU.TEMPLATE.FLOW",
        icon: "fa-solid fa-pager",
        authorities: [Role.MANAGE_FLOW],
      },
      {
        path: "/template/chat-bot",
        label: "MENU.TEMPLATE.BOTS",
        icon: "fa-solid fa-robot",
        authorities: [Role.MANAGE_BOTS],
      },
    ],
  },
  {
    menu: "automations",
    path: "/automations",
    label: "MENU.AUTOMATIONS.TITLE",
    icon: "fa-solid fa-sun",
    groups: ["/MESSAGING"],
    authorities: [
      Role.AUTOMATION,
      Role.AUTOMATION_DEF_ACTIONS,
      Role.CONSULT_NOTIFS,
      Role.MANAGE_BOTS,
      Role.MANAGE_VOUCHER,
    ],
    items: [
      {
        path: "/automations/default-action",
        label: "MENU.AUTOMATIONS.DEFAULT_ACTION",
        icon: "fa-solid fa-envelope",
        authorities: [Role.AUTOMATION_DEF_ACTIONS],
      },
      {
        path: "/automations/notification",
        label: "MENU.AUTOMATIONS.NOTIFICATION",
        icon: "fa-solid fa-bell",
        authorities: [Role.CONSULT_NOTIFS],
      },
      {
        path: "/automations/flows",
        label: "MENU.AUTOMATIONS.FLOWS",
        icon: "fa-solid fa-diagram-project",
        authorities: [Role.MANAGE_BOTS],
      },
      {
        path: "/automations/channel",
        label: "MENU.AUTOMATIONS.CHANNEL",
        icon: "fa-solid fa-icons",
        authorities: [Role.AUTOMATION],
      },
      {
        path: "/automations/ai-assistance",
        label: "MENU.AUTOMATIONS.AIASSISTANT",
        icon: "fa-solid fa-robot",
        authorities: [Role.MANAGE_AIASSISTANT],
      },
      {
        path: "/automations/ai-agents",
        label: "MENU.ADMINISTRATION.AI_AGENTS",
        icon: "fa-solid fa-robot",
        authorities: [Role.MANAGE_AGENT],
      },
      {
        path: "/automations/pending-message",
        label: "MENU.AUTOMATIONS.PENDING_MESSAGE",
        icon: "fa-solid fa-clock",
        authorities: [Role.MANAGE_VOUCHER],
      },
    ],
  },
  {
    menu: "broadcast",
    path: "/broadcast",
    label: "MENU.BROADCAST.TITLE",
    icon: "fa-solid fa-bullhorn",
    groups: ["/MESSAGING"],
    authorities: [
      Role.BROADCAST,
      Role.BROADCAST_ADD,
      Role.BROADCAST_HISTORY,
      Role.BROADCAST_SCHEDULE,
    ],
    items: [
      {
        path: "/broadcast/create",
        label: "MENU.BROADCAST.NEW",
        icon: "fa-solid fa-plus",
        authorities: [Role.BROADCAST_ADD],
      },
      {
        path: "/broadcast/overview",
        label: "MENU.BROADCAST.HISTORIC",
        icon: "fa-solid fa-clock-rotate-left",
        authorities: [Role.BROADCAST_HISTORY],
      },
      {
        path: "/broadcast/scheduled",
        label: "MENU.BROADCAST.SCHEDULED",
        icon: "fa-regular fa-calendar-days",
        authorities: [Role.BROADCAST_SCHEDULE],
      },
    ],
  },
  // ------------------ PAYMENT ------------------
  {
    menu: "payment",
    path: "/payment",
    label: "MENU.PAYMENT.TITLE",
    icon: "fa-solid fa-credit-card",
    groups: ["/PAYMENT"],
    authorities: [Role.MANAGE_PAYMENT_LINK, Role.MANAGE_PAYMENT_AUTHZ],
    items: [
      {
        path: "/payment/list",
        label: "PAYMENT_URL.PAGE.TITLE",
        icon: "fa-solid fa-link",
        authorities: [Role.MANAGE_PAYMENT_LINK],
      },
      {
        path: "/payment/authorization",
        label: "AUTH_DETAILS.MENU_AUTH_LIST",
        icon: "fa-solid fa-list-check",
        authorities: [Role.MANAGE_PAYMENT_AUTHZ],
      },
      {
        path: "/payment/saved-cards",
        label: "SAVED_CARDS.PAGE.TITLE",
        icon: "fa-regular fa-credit-card",
        authorities: [Role.MANAGE_SAVED_CARDS],
      },
    ],
  },
  // ------------------ ADMINISTRATION ------------------
  {
    menu: "administration",
    path: "/administration",
    label: "MENU.ADMINISTRATION.TITLE",
    icon: "fa-brands fa-black-tie",
    groups: ["/ADMINISTRATION"],
    authorities: [Role.MANAGE_AGENT, Role.AUDIT_MANAGE, Role.COMPANY_MANAGE],
    items: [
      {
        path: "/administration/general-parameters",
        label: "MENU.ADMINISTRATION.GENERAL_PARAMS",
        icon: "fa-brands fa-font-awesome",
        authorities: [Role.COMPANY_MANAGE],
      },
      {
        path: "/administration/subscription-meta",
        label: "MENU.ADMINISTRATION.META",
        icon: "fa-brands fa-meta",
        authorities: [Role.COMPANY_MANAGE],
      },
      {
        path: "/administration/catalog",
        label: "MENU.ADMINISTRATION.CATALOG",
        icon: "fa-solid fa-book",
        authorities: [Role.COMPANY_MANAGE],
      },
      /* {
        path: "/administration/subscription-meta-catalog",
        label: "MENU.ADMINISTRATION.CATALOG_SUB",
        icon: "fa-brands fa-meta",
        authorities: [Role.CATALOG_SUBSCRIPTION],
      }, */
      {
        path: "/administration/agent",
        label: "MENU.ADMINISTRATION.AGENTS",
        icon: "fa-solid fa-user-tie",
        authorities: [Role.MANAGE_AGENT],
      },
      {
        path: "/administration/agent-group",
        label: "MENU.ADMINISTRATION.GROUP_AGENT",
        icon: "fa-solid fa-users",
        authorities: [Role.MANAGE_AGENT],
      },
      {
        path: "/administration/audit",
        label: "MENU.ADMINISTRATION.AUDIT",
        icon: "fa-solid fa-newspaper",
        authorities: [Role.AUDIT_MANAGE],
      },
      {
        path: "/subscription/cards",
        label: "MENU.SUBSCRIPTION.CARDS",
        icon: "fa-solid fa-credit-card",
        authorities: [Role.MANAGE_SUBSCRIPTION],
      },
      /* {
        path: "/administration/faq",
        label: "MENU.ADMINISTRATION.FAQ",
        icon: "fa-solid fa-question-circle",
        authorities: [Role.AUDIT_MANAGE],
      }, */
    ],
  },
  {
    menu: "referential",
    path: "/referential",
    label: "MENU.REFERENTIAL.TITLE",
    icon: "fa-solid fa-folder-open",
    groups: ["/ADMINISTRATION"],
    authorities: [
      Role.REFERENTIAL_MANAGE,
      Role.REFERENTIAL_VAR_MANAGE,
      Role.MANAGE_ATTRIBUTE,
    ],
    items: [
      {
        path: "/referential/quick-response",
        label: "MENU.REFERENTIAL.QUICK_RESPONSE",
        icon: "fa-solid fa-bolt",
        authorities: [Role.REFERENTIAL_MANAGE],
      },
      {
        path: "/referential/tag",
        label: "MENU.REFERENTIAL.TAG",
        icon: "fa-solid fa-tags",
        authorities: [Role.REFERENTIAL_MANAGE],
      },
      {
        path: "/referential/attribute",
        label: "MENU.REFERENTIAL.ATTRIBUTE",
        icon: "fa-solid fa-address-card",
        authorities: [Role.REFERENTIAL_MANAGE, Role.MANAGE_ATTRIBUTE],
      },
      {
        path: "/referential/variable",
        label: "MENU.REFERENTIAL.VARIABLE",
        icon: "fa-solid fa-list-check",
        authorities: [Role.REFERENTIAL_VAR_MANAGE, Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/referential/category",
        label: "MENU.REFERENTIAL.CATEGORY",
        icon: "fa-solid fa-layer-group",
        authorities: [Role.REFERENTIAL_MANAGE],
      },
      {
        path: "/referential/channel",
        label: "MENU.REFERENTIAL.CHANNEL",
        icon: "fa-solid fa-icons",
        authorities: [Role.REFERENTIAL_MANAGE],
      },
      {
        path: "/referential/template-folder",
        label: "MENU.REFERENTIAL.TEMPLATE_FOLDER",
        icon: "fa-solid fa-folder-blank",
        authorities: [Role.REFERENTIAL_MANAGE],
      },
      {
        path: "/referential/devise",
        label: "MENU.REFERENTIAL.DEVISE",
        icon: "fa-solid fa-coins",
        authorities: [Role.ADMIN_SOLUTION_UI, Role.REFERENTIAL_DEVISE_MANAGE],
      },
      {
        path: "/referential/delivery-method",
        label: "MENU.REFERENTIAL.DELIVERY_METHOD",
        icon: "fa-solid fa-truck",
        authorities: [Role.REFERENTIAL_MANAGE],
      },
      {
        path: "/referential/payment-method",
        label: "MENU.REFERENTIAL.PAYMENT_METHOD",
        icon: "fa-solid fa-credit-card",
        authorities: [Role.REFERENTIAL_MANAGE],
      },
      {
        path: "/referential/category-ticket",
        label: "MENU.SOLUTION.CATEGORY_TICKET",
        icon: "fa-solid fa-list",
        authorities: [Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/referential/status-ticket",
        label: "MENU.SOLUTION.STATUS_TICKET",
        icon: "fa-solid fa-info-circle",
        authorities: [Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/referential/tags-ticket",
        label: "MENU.SOLUTION.TAGS_TICKET",
        icon: "fa-solid fa-hashtag",
        authorities: [Role.ADMIN_SOLUTION_UI],
      },
    ],
  },

  // ------------------ SOLUTION ------------------
  {
    menu: "solution",
    path: "/solution",
    label: "MENU.SOLUTION.TITLE",
    icon: "fa-solid fa-passport",
    groups: ["/SOLUTION"],
    authorities: [
      Role.ADMIN_SOLUTION,
      Role.DASHY_COMPANIES,
      Role.ADMIN_SOLUTION_UI,
    ],
    items: [
      /* {
        path: "/solution/module",
        label: "MENU.SOLUTION.MODULES",
        icon: "fa-solid fa-folder-tree",
        authorities: [Role.ADMIN_SOLUTION, Role.ADMIN_SOLUTION_UI],
      }, */
      {
        path: "/solution/company",
        label: "MENU.SOLUTION.COMPANIES",
        icon: "fa-brands fa-font-awesome",
        authorities: [Role.DASHY_COMPANIES, Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/solution/conversations",
        label: "MENU.SOLUTION.CONVERSATIONS",
        icon: "fa-brands fa-stack-exchange",
        authorities: [Role.ADMIN_CONVERSATIONS, Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/solution/manage-phones",
        label: "MENU.SOLUTION.MANAGE_COMPANY",
        icon: "fa-solid fa-phone",
        authorities: [Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/solution/admin-dashboard",
        label: "MENU.SOLUTION.DASHBOARD_ADMIN",
        icon: "fa-solid fa-chart-simple",
        authorities: [Role.ADMIN_CONVERSATIONS, Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/solution/video-tutorial",
        label: "MENU.SOLUTION.VIDEO_TUTORIAL",
        icon: "fa-solid fa-circle-play",
        authorities: [Role.ADMIN_CONVERSATIONS, Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/solution/consommation",
        label: "MENU.SOLUTION.PRICING_ANALITYCS",
        icon: "fa-solid fa-layer-group",
        authorities: [Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/solution/recharge",
        label: "MENU.SOLUTION.RECHARGE",
        icon: "fa-solid fa-credit-card",
        authorities: [Role.ADMIN_SOLUTION_UI],
      },
      {
        path: "/subscription/plans",
        label: "PLAN_LIST.PAGE.TITLE",
        icon: "fa-solid fa-list",
        authorities: [Role.MANAGE_SUBSCRIPTION], // TODO
      },
    ],
  },
];
